import React from 'react'
import { useSelector } from 'react-redux'
import { Button } from 'shards-react'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import addFont from '../../../../fonts/fonts'
import styles from '../styles.module.css'


const orientation = 'l'
const fileTitle = 'Сведения об обучающихся (форма №4СВУ)'

const FONT_NAME = 'Montserrat'
const BODY_FONT_SIZE = 8
const HEAD_FONT_SIZE = 8
const VERTICAL_FONT_SIZE = 7
const VERTICAL_HEAD_HEIGHT = 45

const fmt = (v) => (v === null || v === undefined || v === '') ? '—' : v

const formatDate = (d) => {
  if (!d) return ''
  const s = String(d).slice(0, 10)
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, day] = s.split('-')
    return `${day}.${m}.${y}`
  }
  return s
}

const numberAndDate = (number, date) => {
  const n = (number === null || number === undefined || number === '') ? '' : String(number)
  const d = formatDate(date)
  if (!n && !d) return '—'
  if (n && d) return `${n}\nот ${d}`
  return n || `от ${d}`
}

const GRADES = [
  { key: 'total', label: 'Всего',    staff: 'staffTotal', list: 'listTotal' },
  { key: 'g5',    label: '5 класс',  staff: 'staff5',     list: 'list5' },
  { key: 'g6',    label: '6 класс',  staff: 'staff6',     list: 'list6' },
  { key: 'g7',    label: '7 класс',  staff: 'staff7',     list: 'list7' },
  { key: 'g8',    label: '8 класс',  staff: 'staff8',     list: 'list8' },
  { key: 'g9',    label: '9 класс',  staff: 'staff9',     list: 'list9' },
  { key: 'g10',   label: '10 класс', staff: 'staff10',    list: 'list10' },
  { key: 'g11',   label: '11 класс', staff: 'staff11',    list: 'list11' },
]

const SOCIAL_BEFORE = [
  { key: 'orphans',  label: 'Количество детей-сирот без оставшихся без попечения родителей', field: 'orphansCount' },
  { key: 'military', label: 'Количество детей военнослужащих',                                field: 'militaryChildren' },
  { key: 'lawEnf',   label: 'Количество детей работников силовых ведомств',                   field: 'lawEnforcementChildren' },
]

const SVO = [
  { key: 'svoTotal',   label: 'Всего',                       field: 'svoTotal' },
  { key: 'svoWounded', label: 'Получивших ранения, увечья',  field: 'svoWounded' },
  { key: 'svoDead',    label: 'Погибших',                    field: 'svoDead' },
]

const HEALTH = [
  { key: 'health1', label: 'Количество детей с 1 группой здоровья',  field: 'health1' },
  { key: 'health2', label: 'Количество детей со 2 группой здоровья', field: 'health2' },
  { key: 'health3', label: 'Количество детей с 3 группой здоровья',  field: 'health3' },
]

const NOO_CLASSES = ['1', '2', '3', '4']
const OOO_CLASSES = ['5', '6', '7', '8', '9']
const SOO_CLASSES = ['10', '11']
const SCHOOL_GROUPS = [
  { title: 'Начальное общее образование', classes: NOO_CLASSES },
  { title: 'Основное общее образование',  classes: OOO_CLASSES },
  { title: 'Среднее общее образование',   classes: SOO_CLASSES },
]
const SCHOOL_RIGHT_COLS = [
  { label: 'Детей военнослужащих',  field: 'militaryChildren' },
  { label: 'Детей ГП ВС',           field: 'civPersonnelMoD' },
  { label: 'Детей с ОВЗ',           field: 'ovzChildren' },
  { label: 'Штатная наполняемость', field: 'totalStaffQuota' },
]

const numVal = (v) => {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}
const sumOf = (row, fields) => fields.reduce((acc, f) => acc + numVal(row[f]), 0)


const byId = (rows) => {
  const result = {}
  ;(rows || []).forEach(r => {
    if (!result[r.organizationId]) result[r.organizationId] = []
    result[r.organizationId].push(r)
  })
  return result
}

const v = (content, extra = {}) => ({ content, ...extra, _vertical: true })


export default function Buttons ({ visible, data }) {

  const isSchools = useSelector(state => state.reports.studentsInfo.mode) === 'schools'

  const drawPageHeader = (doc, { tableNumber, tableTitle, organizationName, yearTitle }) => {
    const { width } = doc.internal.pageSize
    const margin = 14
    const sideLabelReserve = 70
    let y = 12

    doc.setFontSize(9)
    doc.setFont(FONT_NAME, 'bold')
    doc.text('Министерство обороны Российской Федерации', width / 2, y, { align: 'center' })
    y += 4
    doc.text('Департамент военного образования', width / 2, y, { align: 'center' })
    doc.setFont(FONT_NAME, 'normal')
    y += 6

    doc.setFontSize(10)
    doc.text('Форма №4/СВУ', width - margin, y, { align: 'right' })

    doc.setFontSize(11)
    const titleText = yearTitle ? `${tableTitle} ${yearTitle}` : tableTitle
    const titleLines = doc.splitTextToSize(
      titleText,
      width - margin * 2 - sideLabelReserve,
    )
    titleLines.forEach(line => {
      doc.text(line, width / 2, y, { align: 'center' })
      y += 6
    })

    doc.setFontSize(10)
    doc.text(`Таблица №${tableNumber}`, width - margin, y, { align: 'right' })

    if (organizationName) {
      doc.setFontSize(11)
      const orgLines = doc.splitTextToSize(organizationName, width - margin * 2 - sideLabelReserve)
      orgLines.forEach(line => {
        doc.text(line, width / 2, y, { align: 'center' })
        y += 6
      })
    }

    return y + 2
  }

  const verticalHeadHooks = {
    didParseCell: (hookData) => {
      const raw = hookData.cell.raw
      if (hookData.section === 'head' && raw && typeof raw === 'object' && raw._vertical) {
        hookData.cell._verticalContent = String(raw.content ?? '')
        hookData.cell.text = []
        if ((hookData.cell.styles.minCellHeight || 0) < VERTICAL_HEAD_HEIGHT) {
          hookData.cell.styles.minCellHeight = VERTICAL_HEAD_HEIGHT
        }
      }
    },
    didDrawCell: (hookData) => {
      const cell = hookData.cell
      const text = cell._verticalContent
      if (!text) return
      const { doc } = hookData

      doc.setFont(FONT_NAME)
      doc.setFontSize(VERTICAL_FONT_SIZE)

      const ptToMm = 0.3528
      const lineHeightMm = VERTICAL_FONT_SIZE * 1.2 * ptToMm
      const availHeight = cell.height - 3
      const lines = doc.splitTextToSize(text, availHeight)

      const totalBlockWidth = lines.length * lineHeightMm
      const firstLineX = cell.x + (cell.width - totalBlockWidth) / 2 + lineHeightMm / 2
      const baseY = cell.y + cell.height - 1.5

      lines.forEach((line, i) => {
        doc.text(line, firstLineX + i * lineHeightMm, baseY, {
          angle: 90,
          align: 'left',
        })
      })
    },
  }

  const baseTableOptions = (startY) => ({
    startY,
    margin: { left: 14, right: 14 },
    tableWidth: 'auto',
    styles: {
      font: FONT_NAME,
      fontSize: BODY_FONT_SIZE,
      cellPadding: 2,
      lineWidth: 0.1,
      lineColor: 200,
      halign: 'center',
      valign: 'middle',
      overflow: 'linebreak',
    },
    headStyles: {
      fillColor: [250, 250, 250],
      textColor: 20,
      fontStyle: 'bold',
      fontSize: HEAD_FONT_SIZE,
      halign: 'center',
      valign: 'middle',
    },
    theme: 'grid',
    ...verticalHeadHooks,
  })

  const drawSummaryTable = (doc, row, startY) => {
    const head = [
      [
        ...GRADES.map(g => ({ content: g.label, colSpan: 2 })),
        ...SOCIAL_BEFORE.map(s => v(s.label, { rowSpan: 2 })),
        { content: 'Количество детей участников СВО', colSpan: SVO.length },
        ...HEALTH.map(h => v(h.label, { rowSpan: 2 })),
      ],
      [
        ...GRADES.flatMap(() => [v('По штату'), v('По списку')]),
        ...SVO.map(s => v(s.label)),
      ],
    ]
    const body = [
      [
        ...GRADES.flatMap(g => [fmt(row[g.staff]), fmt(row[g.list])]),
        ...SOCIAL_BEFORE.map(s => fmt(row[s.field])),
        ...SVO.map(s => fmt(row[s.field])),
        ...HEALTH.map(h => fmt(row[h.field])),
      ],
    ]
    doc.autoTable({ ...baseTableOptions(startY), head, body })
  }

  const drawSummarySchoolsTable = (doc, row, startY) => {
    const head = [
      [
        { content: 'Группы продлённого дня', colSpan: 2 },
        ...SCHOOL_GROUPS.map(g => ({ content: g.title, colSpan: (g.classes.length + 1) * 2 })),
        { content: 'Итого', colSpan: 2 },
        ...SCHOOL_RIGHT_COLS.map(c => v(c.label, { rowSpan: 3 })),
      ],
      [
        v('гр.', { rowSpan: 2 }),
        v('чел.', { rowSpan: 2 }),
        ...SCHOOL_GROUPS.flatMap(g => [
          ...g.classes.map(c => ({ content: `${c} класс`, colSpan: 2 })),
          { content: 'Всего', colSpan: 2 },
        ]),
        v('кл.', { rowSpan: 2 }),
        v('чел.', { rowSpan: 2 }),
      ],
      [
        ...SCHOOL_GROUPS.flatMap(g => [
          ...g.classes.flatMap(() => [v('кл.'), v('чел.')]),
          v('кл.'),
          v('чел.'),
        ]),
      ],
    ]
    const body = [
      [
        fmt(row.gpdCount),
        fmt(row.gpdStudentsCount),
        ...SCHOOL_GROUPS.flatMap(g => {
          const classesFields = g.classes.map(c => `classes${c}`)
          const listFields = g.classes.map(c => `list${c}`)
          return [
            ...g.classes.flatMap(c => [fmt(row[`classes${c}`]), fmt(row[`list${c}`])]),
            sumOf(row, classesFields),
            sumOf(row, listFields),
          ]
        }),
        fmt(row.classesTotal),
        fmt(row.listTotal),
        ...SCHOOL_RIGHT_COLS.map(c => fmt(row[c.field])),
      ],
    ]
    doc.autoTable({ ...baseTableOptions(startY), head, body })
  }

  const drawDischargedTable = (doc, rows, startY) => {
    const sorted = [...(rows || [])].sort((a, b) => {
      const fa = (a.fio || '').toLowerCase()
      const fb = (b.fio || '').toLowerCase()
      return fa.localeCompare(fb, 'ru')
    })
    const head = [[
      '№ п/п',
      'ФИО обучающегося',
      'Класс',
      'Причины отчисления',
      'Дата и номер приказа НУ',
      'Дата и номер протокола педагогического совета',
      'Примечание',
    ]]
    const body = sorted.length
      ? sorted.map((s, i) => [
        i + 1,
        fmt(s.fio),
        fmt(s.className),
        fmt(s.dischargeReason),
        numberAndDate(s.orderNumber, s.orderDate),
        numberAndDate(s.protocolNumber, s.protocolDate),
        fmt(s.note),
      ])
      : [[{ content: 'Нет отчисленных за период', colSpan: 7 }]]
    doc.autoTable({
      ...baseTableOptions(startY),
      head,
      body,
      columnStyles: {
        0: { cellWidth: 12 },
        1: { halign: 'left', cellWidth: 60 },
        2: { cellWidth: 18 },
        3: { halign: 'left' },
      },
    })
  }

  const getPdfData = async () => {
    addFont(jsPDF.API)
    const doc = new jsPDF({ putOnlyUsedFonts: true, orientation, format: 'a4' })

    doc.setFont(FONT_NAME)

    const summaryRows = data?.summary?.rows || []
    const dischargedById = byId(data?.discharged?.rows)

    const academicYear = data?.discharged?.academicYear || data?.summary?.academicYear
    const dischargeYearTitle = academicYear
      ? `в ${academicYear} учебном году`
      : 'за учебный год'

    let isFirstPage = true

    const openPage = () => {
      if (!isFirstPage) doc.addPage('a4', orientation)
      isFirstPage = false
    }

    const hasDischarged = !!data?.discharged

    summaryRows.forEach(org => {
      const orgId = org.organizationId
      const organizationName = org.organizationName
      const dischargedRows = dischargedById[orgId] || []

      openPage()
      let y = drawPageHeader(doc, {
        tableNumber: 1,
        tableTitle: 'Сведения об обучающихся',
        organizationName,
      })
      if (isSchools) {
        drawSummarySchoolsTable(doc, org, y)
      } else {
        drawSummaryTable(doc, org, y)
      }

      if (hasDischarged) {
        openPage()
        y = drawPageHeader(doc, {
          tableNumber: 2,
          tableTitle: 'Сведения об отчисленных',
          organizationName,
          yearTitle: dischargeYearTitle,
        })
        drawDischargedTable(doc, dischargedRows, y)
      }
    })

    return doc
  }

  const toPdf = () => {
    getPdfData().then(doc => doc.save(`${fileTitle}.pdf`))
  }

  if (!visible) return null

  return (
    <div className={styles.buttonsBlock}>
      <Button theme='danger' className={'mb-2'} onClick={toPdf}>
        Скачать .pdf
      </Button>
    </div>
  )
}
